const _prefix = '@locale/';

export default {
  SET_INTL: _prefix + 'SET_INTL',
  CHANGE_LOCALE: _prefix + 'CHANGE_LOCALE'
};
